import '../../styles/settings.css';
import DeferredImage from "./DeferredImage";
import { CDN_BASE_URL } from "../../helper/image";

const ImageComponent = ({ imageSrc }) => {
    return (
        <DeferredImage
          className="img"
          src={`${CDN_BASE_URL}${imageSrc}`}
          loading="lazy"
        />
    );
  };

export default ImageComponent;
